export enum LoaderType {
    FACEBOOK = 'Facebook',
    INSTAGRAM = 'Instagram',
    CODE = 'Code',
    LIST = 'List',
    BULLET_LIST = 'BulletList',
    CUSTOM_SVG = 'CustomSvg',
    CIRCLE = 'Circle',
}
